import { Stack, Tooltip, styled } from '@mui/material'
import Iconfont from 'components/Iconfont'
import { TrendColorizer } from 'components/TrendColorizer'
import { memo } from 'react'
import { useOrderbook } from 'store/orderbook/hooks'
import { OrderDirection } from 'store/spot/types'
import { toFixed } from 'utils/number'

const Wrap = styled(Stack)``
export const CurrentPrice = styled(Stack)`
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-size: 24px;
  line-height: 24px;
  font-weight: 700;

  ${(props) => props.theme.breakpoints.down('md')} {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    // display: none;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 36px;
    border: 1px solid ${(props) => props.theme.color.text20};
    border-left: none;
    border-right: none;
    border-bottom: none;
  }
`
const IconUp = styled(Iconfont)`
  color: rgba(65, 158, 106, 1);
`
const IconDown = styled(Iconfont)`
  color: rgba(227, 85, 97, 1);
`

export const OrderbookTicker = memo<{
  quoteScale: number
}>(({ quoteScale }) => {
  const orderbook = useOrderbook()
  const { price = 0, direction = OrderDirection.LONG } = orderbook
  const isLong = direction === OrderDirection.LONG

  return (
    <Wrap>
      <Tooltip
        title={
          <Stack gap={0.5}>
            <h3
              style={{
                margin: '0',
                fontWeight: 600,
                fontSize: '16px',
                lineHeight: '24px',
              }}
            >
              Last Price
            </h3>
            The last trade price of the market.
          </Stack>
        }
        arrow
        placement="left-start"
      >
        <CurrentPrice>
          <TrendColorizer
            trend={isLong}
            value={toFixed(price, quoteScale, { fixed: true })}
          />
          {isLong ? (
            <IconUp name="icon-Up" size={16} />
          ) : (
            <IconDown name="icon-Down" size={16} />
          )}
        </CurrentPrice>
      </Tooltip>
    </Wrap>
  )
})
